import React from "react";
import PdfBase from "../../Others/Pdf/PdfBase";
import { generateCaSummaryPdf } from "./generator";
import ExcelBase from "../../Others/Excel/ExcelBase";

const PdfGenerator = ({
  schedule,
  company,
  summary,
  netTotal,
  notes,
  reviewNotes,
}) => {
  const sharedArgs = [schedule, company, summary, netTotal, notes, reviewNotes];

  return (
    <>
      <PdfBase
        company={company}
        generatePdf={(forView) => generateCaSummaryPdf(forView, ...sharedArgs)}
        downloadName='CA Summary'
        enableDraftView
      />
      <ExcelBase
        generateExcel={(forView) =>
          generateCaSummaryPdf(forView, ...sharedArgs, true)
        }
      />
    </>
  );
};

export default PdfGenerator;
